export const t = stringToTranslate => stringToTranslate;

export const theme = {
  palette: {
    primary: {
      light: '#F2FAFF;',
      dark: '#0094EE',
      main: '#00A1FB',
      darker: '#0053A7',
      darkest: '#002940',
      contrastText: '#fff'
    },
    secondary: {
      light: '#E0F4FF',
      dark: '#496D91',
      main: '#02A1FB',
      mainDarker: '#0068C2',
      mainLighter: '#5A85B0',
      contrastText: '#fff'
    }
  }
};

//TODO - this will change once the backend data model is designed
export const mockInvoiceData = [
  {
    id: 1234567890,
    shipmentId: 1000,
    carrierInvoiceNumber: 12345678,
    quoted: 545,
    invoiced: 525,
    showAsException: false,
    carrierName: 'HC-XYZ Shipping Company',
    actualDelivery: '2019-02-08T18:04:30.5900651',
    invoiceDate: '2019-02-09T18:04:30.5900651',
    dueDate: '2019-02-24T18:04:30.5900651',
    status: 'IN_REVIEW'
  },
  {
    id: 8172619232,
    shipmentId: 1001,
    carrierInvoiceNumber: 87318273,
    quoted: 231.5,
    invoiced: 235,
    showAsException: false,
    carrierName: 'HC-XYZ Shipping Company',
    actualDelivery: '2019-02-07T18:04:30.5900651',
    invoiceDate: '2019-02-10T18:04:30.5900651',
    dueDate: '2019-02-20T18:04:30.5900651',
    status: 'DISPUTED'
  },
  {
    id: 9654278188,
    shipmentId: 1002,
    carrierInvoiceNumber: 99871272,
    quoted: 130.25,
    invoiced: 187.12,
    showAsException: true,
    carrierName: "HC-Bob's Shipping",
    actualDelivery: '2019-02-02T18:04:30.5900651',
    invoiceDate: '2019-02-10T18:04:30.5900651',
    dueDate: '2019-03-08T18:04:30.5900651',
    status: 'AWAITING_DOCUMENTS'
  },
  {
    id: 6667612281,
    shipmentId: 1003,
    carrierInvoiceNumber: 76218123,
    quoted: 105,
    invoiced: 105,
    showAsException: false,
    carrierName: 'HC-Heavy Trucks',
    actualDelivery: '2019-01-08T18:04:30.5900651',
    invoiceDate: '2019-01-09T18:04:30.5900651',
    dueDate: '2019-02-09T18:04:30.5900651',
    status: 'READY_TO_REMIT'
  },
  {
    id: null,
    shipmentId: 1005,
    carrierInvoiceNumber: 33891123,
    quoted: 765.88,
    invoiced: null,
    showAsException: false,
    carrierName: 'HC-XYZ Shipping Company',
    actualDelivery: '2019-02-08T18:04:30.5900651',
    invoiceDate: null,
    dueDate: null,
    status: 'IN_REVIEW'
  },
  {
    id: 9887123476,
    shipmentId: 1008,
    carrierInvoiceNumber: 76767612,
    quoted: 511.54,
    invoiced: 511.54,
    showAsException: false,
    carrierName: 'HC-Bobs Shipping Company',
    actualDelivery: null,
    invoiceDate: '2019-02-09T18:04:30.5900651',
    dueDate: '2019-02-24T18:04:30.5900651',
    status: 'PROCESSED'
  },
  {
    id: 98654123476,
    shipmentId: 1006,
    carrierInvoiceNumber: 88476353,
    quoted: 525,
    invoiced: 525,
    showAsException: false,
    carrierName: 'HC-XYZ Shipping Company',
    actualDelivery: null,
    invoiceDate: '2019-02-09T18:04:30.5900651',
    dueDate: '2019-02-24T18:04:30.5900651',
    status: 'AWAITING_REVISION'
  },
  {
    id: 88854123476,
    shipmentId: 1007,
    carrierInvoiceNumber: 87392923,
    quoted: 525,
    invoiced: 525,
    showAsException: false,
    carrierName: 'HC-XYZ Shipping Company',
    actualDelivery: '2019-02-09T18:04:30.5900651',
    invoiceDate: '2019-02-09T18:04:30.5900651',
    dueDate: '2019-02-24T18:04:30.5900651',
    status: 'REJECTED'
  },
  {
    id: 11288212312,
    shipmentId: null,
    carrierInvoiceNumber: null,
    quoted: null,
    invoiced: null,
    showAsException: false,
    carrierName: null,
    actualDelivery: null,
    invoiceDate: null,
    dueDate: null,
    status: 'PARSING_ERROR'
  }
];

export const mockReferenceData = {
  referenceData: {
    fileTypes: [
      {
        value: 'JPG',
        title: 'JPG',
        data: { name: 'JPG', enumValue: 'JPG', __typename: 'RefFileType' }
      },
      {
        value: 'PDF',
        title: 'PDF',
        data: { name: 'PDF', enumValue: 'PDF', __typename: 'RefFileType' }
      },
      {
        value: 'PNG',
        title: 'PNG',
        data: { name: 'PNG', enumValue: 'PNG', __typename: 'RefFileType' }
      }
    ],
    filePurposes: [
      {
        value: 'BRANDING',
        title: 'Branding',
        data: {
          name: 'Branding',
          enumValue: 'BRANDING',
          __typename: 'RefFilePurpose'
        }
      },
      {
        value: 'EDI',
        title: 'EDI',
        data: { name: 'EDI', enumValue: 'EDI', __typename: 'RefFilePurpose' }
      },
      {
        value: 'IMPORT',
        title: 'Import',
        data: {
          name: 'Import',
          enumValue: 'IMPORT',
          __typename: 'RefFilePurpose'
        }
      },
      {
        value: 'OTHER',
        title: 'Other',
        data: {
          name: 'Other',
          enumValue: 'OTHER',
          __typename: 'RefFilePurpose'
        }
      },
      {
        value: 'SHIPMENT',
        title: 'Shipment',
        data: {
          name: 'Shipment',
          enumValue: 'SHIPMENT',
          __typename: 'RefFilePurpose'
        }
      }
    ],
    shipmentDocumentTypes: [
      {
        value: 'BOL',
        title: 'BOL',
        data: {
          name: 'BOL',
          enumValue: 'BOL',
          __typename: 'RefShipmentDocumentType'
        }
      },
      {
        value: 'INVOICE',
        title: 'Invoice',
        data: {
          name: 'Invoice',
          enumValue: 'INVOICE',
          __typename: 'RefShipmentDocumentType'
        }
      },
      {
        value: 'OTHER',
        title: 'Other',
        data: {
          name: 'Other',
          enumValue: 'OTHER',
          __typename: 'RefShipmentDocumentType'
        }
      },
      {
        value: 'PICKUP_RECEIPT',
        title: 'PickupReceipt',
        data: {
          name: 'PickupReceipt',
          enumValue: 'PICKUP_RECEIPT',
          __typename: 'RefShipmentDocumentType'
        }
      },
      {
        value: 'PROOF_OF_DELIVERY',
        title: 'ProofOfDelivery',
        data: {
          name: 'ProofOfDelivery',
          enumValue: 'PROOF_OF_DELIVERY',
          __typename: 'RefShipmentDocumentType'
        }
      },
      {
        value: 'SIGNED_BOL',
        title: 'SignedBOL',
        data: {
          name: 'SignedBOL',
          enumValue: 'SIGNED_BOL',
          __typename: 'RefShipmentDocumentType'
        }
      },
      {
        value: 'WEIGHT_CERTIFICATE',
        title: 'WeightCertificate',
        data: {
          name: 'WeightCertificate',
          enumValue: 'WEIGHT_CERTIFICATE',
          __typename: 'RefShipmentDocumentType'
        }
      }
    ],
    equipmentTypes: [
      {
        value: 'ET_2_B',
        title: '20 ft. IL Container (Closed Top)',
        data: {
          enumValue: 'ET_2_B',
          name: '2B',
          description: '20 ft. IL Container (Closed Top)',
          __typename: 'RefEquipmentType'
        }
      },
      {
        value: 'ET_20',
        title: '20 ft. IL Container (Open Top)',
        data: {
          enumValue: 'ET_20',
          name: '20',
          description: '20 ft. IL Container (Open Top)',
          __typename: 'RefEquipmentType'
        }
      },
      {
        value: 'ET_4_B',
        title: '40 ft. IL Container (Closed Top)',
        data: {
          enumValue: 'ET_4_B',
          name: '4B',
          description: '40 ft. IL Container (Closed Top)',
          __typename: 'RefEquipmentType'
        }
      },
      {
        value: 'ET_40',
        title: '40 ft. IL Container (Open Top)',
        data: {
          enumValue: 'ET_40',
          name: '40',
          description: '40 ft. IL Container (Open Top)',
          __typename: 'RefEquipmentType'
        }
      },
      {
        value: 'AF',
        title: 'Air Freight (Break Bulk)',
        data: {
          enumValue: 'AF',
          name: 'AF',
          description: 'Air Freight (Break Bulk)',
          __typename: 'RefEquipmentType'
        }
      },
      {
        value: 'AP',
        title: 'Aircraft ',
        data: {
          enumValue: 'AP',
          name: 'AP',
          description: 'Aircraft ',
          __typename: 'RefEquipmentType'
        }
      },
      {
        value: 'BR',
        title: 'Barge',
        data: {
          enumValue: 'BR',
          name: 'BR',
          description: 'Barge',
          __typename: 'RefEquipmentType'
        }
      },
      {
        value: 'BO',
        title: 'Barge Open',
        data: {
          enumValue: 'BO',
          name: 'BO',
          description: 'Barge Open',
          __typename: 'RefEquipmentType'
        }
      },
      {
        value: 'BF',
        title: 'Bilevel Railcar Fully Enclosed',
        data: {
          enumValue: 'BF',
          name: 'BF',
          description: 'Bilevel Railcar Fully Enclosed',
          __typename: 'RefEquipmentType'
        }
      },
      {
        value: 'BE',
        title: 'Bilevel Railcar Fully Open',
        data: {
          enumValue: 'BE',
          name: 'BE',
          description: 'Bilevel Railcar Fully Open',
          __typename: 'RefEquipmentType'
        }
      },
      {
        value: 'BH',
        title: 'Bilevel Railcar Screened With Roof',
        data: {
          enumValue: 'BH',
          name: 'BH',
          description: 'Bilevel Railcar Screened With Roof',
          __typename: 'RefEquipmentType'
        }
      },
      {
        value: 'BJ',
        title: 'Bilevel Railcar Screened, No Roof',
        data: {
          enumValue: 'BJ',
          name: 'BJ',
          description: 'Bilevel Railcar Screened, No Roof',
          __typename: 'RefEquipmentType'
        }
      }
    ],
    freightClasses: [
      {
        value: 'CLASS_100',
        title: 'Class100',
        data: {
          enumValue: 'CLASS_100',
          name: 'Class100',
          __typename: 'RefFreightClass'
        }
      },
      {
        value: 'CLASS_110',
        title: 'Class110',
        data: {
          enumValue: 'CLASS_110',
          name: 'Class110',
          __typename: 'RefFreightClass'
        }
      },
      {
        value: 'CLASS_125',
        title: 'Class125',
        data: {
          enumValue: 'CLASS_125',
          name: 'Class125',
          __typename: 'RefFreightClass'
        }
      },
      {
        value: 'CLASS_150',
        title: 'Class150',
        data: {
          enumValue: 'CLASS_150',
          name: 'Class150',
          __typename: 'RefFreightClass'
        }
      },
      {
        value: 'CLASS_175',
        title: 'Class175',
        data: {
          enumValue: 'CLASS_175',
          name: 'Class175',
          __typename: 'RefFreightClass'
        }
      },
      {
        value: 'CLASS_200',
        title: 'Class200',
        data: {
          enumValue: 'CLASS_200',
          name: 'Class200',
          __typename: 'RefFreightClass'
        }
      },
      {
        value: 'CLASS_250',
        title: 'Class250',
        data: {
          enumValue: 'CLASS_250',
          name: 'Class250',
          __typename: 'RefFreightClass'
        }
      },
      {
        value: 'CLASS_300',
        title: 'Class300',
        data: {
          enumValue: 'CLASS_300',
          name: 'Class300',
          __typename: 'RefFreightClass'
        }
      },
      {
        value: 'CLASS_400',
        title: 'Class400',
        data: {
          enumValue: 'CLASS_400',
          name: 'Class400',
          __typename: 'RefFreightClass'
        }
      },
      {
        value: 'CLASS_50',
        title: 'Class50',
        data: {
          enumValue: 'CLASS_50',
          name: 'Class50',
          __typename: 'RefFreightClass'
        }
      },
      {
        value: 'CLASS_500',
        title: 'Class500',
        data: {
          enumValue: 'CLASS_500',
          name: 'Class500',
          __typename: 'RefFreightClass'
        }
      },
      {
        value: 'CLASS_55',
        title: 'Class55',
        data: {
          enumValue: 'CLASS_55',
          name: 'Class55',
          __typename: 'RefFreightClass'
        }
      },
      {
        value: 'CLASS_60',
        title: 'Class60',
        data: {
          enumValue: 'CLASS_60',
          name: 'Class60',
          __typename: 'RefFreightClass'
        }
      },
      {
        value: 'CLASS_65',
        title: 'Class65',
        data: {
          enumValue: 'CLASS_65',
          name: 'Class65',
          __typename: 'RefFreightClass'
        }
      },
      {
        value: 'CLASS_70',
        title: 'Class70',
        data: {
          enumValue: 'CLASS_70',
          name: 'Class70',
          __typename: 'RefFreightClass'
        }
      },
      {
        value: 'CLASS_77_5',
        title: 'Class77_5',
        data: {
          enumValue: 'CLASS_77_5',
          name: 'Class77_5',
          __typename: 'RefFreightClass'
        }
      },
      {
        value: 'CLASS_85',
        title: 'Class85',
        data: {
          enumValue: 'CLASS_85',
          name: 'Class85',
          __typename: 'RefFreightClass'
        }
      },
      {
        value: 'CLASS_92_5',
        title: 'Class92_5',
        data: {
          enumValue: 'CLASS_92_5',
          name: 'Class92_5',
          __typename: 'RefFreightClass'
        }
      }
    ],
    hazMatClasses: [
      {
        value: 'CLASS_8',
        title: '8',
        data: {
          enumValue: 'CLASS_8',
          name: '8',
          __typename: 'RefHazMatClass'
        }
      },
      {
        value: 'CLASS_4_3',
        title: '4.3',
        data: {
          enumValue: 'CLASS_4_3',
          name: '4.3',
          __typename: 'RefHazMatClass'
        }
      },
      {
        value: 'CLASS_1_1',
        title: '1.1',
        data: {
          enumValue: 'CLASS_1_1',
          name: '1.1',
          __typename: 'RefHazMatClass'
        }
      },
      {
        value: 'CLASS_1_2',
        title: '1.2',
        data: {
          enumValue: 'CLASS_1_2',
          name: '1.2',
          __typename: 'RefHazMatClass'
        }
      },
      {
        value: 'CLASS_1_4',
        title: '1.4',
        data: {
          enumValue: 'CLASS_1_4',
          name: '1.4',
          __typename: 'RefHazMatClass'
        }
      },
      {
        value: 'CLASS_1_3',
        title: '1.3',
        data: {
          enumValue: 'CLASS_1_3',
          name: '1.3',
          __typename: 'RefHazMatClass'
        }
      },
      {
        value: 'CLASS_1_6',
        title: '1.6',
        data: {
          enumValue: 'CLASS_1_6',
          name: '1.6',
          __typename: 'RefHazMatClass'
        }
      },
      {
        value: 'CLASS_3',
        title: '3',
        data: {
          enumValue: 'CLASS_3',
          name: '3',
          __typename: 'RefHazMatClass'
        }
      },
      {
        value: 'CLASS_2_1',
        title: '2.1',
        data: {
          enumValue: 'CLASS_2_1',
          name: '2.1',
          __typename: 'RefHazMatClass'
        }
      },
      {
        value: 'CLASS_4_1',
        title: '4.1',
        data: {
          enumValue: 'CLASS_4_1',
          name: '4.1',
          __typename: 'RefHazMatClass'
        }
      },
      {
        value: 'NONE',
        title: 'None',
        data: {
          enumValue: 'NONE',
          name: 'None',
          __typename: 'RefHazMatClass'
        }
      },
      {
        value: 'CLASS_6_2',
        title: '6.2',
        data: {
          enumValue: 'CLASS_6_2',
          name: '6.2',
          __typename: 'RefHazMatClass'
        }
      },
      {
        value: 'CLASS_9',
        title: '9',
        data: {
          enumValue: 'CLASS_9',
          name: '9',
          __typename: 'RefHazMatClass'
        }
      },
      {
        value: 'CLASS_2_2',
        title: '2.2',
        data: {
          enumValue: 'CLASS_2_2',
          name: '2.2',
          __typename: 'RefHazMatClass'
        }
      },
      {
        value: 'CLASS_5_2',
        title: '5.2',
        data: {
          enumValue: 'CLASS_5_2',
          name: '5.2',
          __typename: 'RefHazMatClass'
        }
      },
      {
        value: 'CLASS_5_1',
        title: '5.1',
        data: {
          enumValue: 'CLASS_5_1',
          name: '5.1',
          __typename: 'RefHazMatClass'
        }
      },
      {
        value: 'CLASS_2_3',
        title: '2.3',
        data: {
          enumValue: 'CLASS_2_3',
          name: '2.3',
          __typename: 'RefHazMatClass'
        }
      },
      {
        value: 'CLASS_6_1',
        title: '6.1',
        data: {
          enumValue: 'CLASS_6_1',
          name: '6.1',
          __typename: 'RefHazMatClass'
        }
      },
      {
        value: 'CLASS_7',
        title: '7',
        data: {
          enumValue: 'CLASS_7',
          name: '7',
          __typename: 'RefHazMatClass'
        }
      },
      {
        value: 'CLASS_4_2',
        title: '4.2',
        data: {
          enumValue: 'CLASS_4_2',
          name: '4.2',
          __typename: 'RefHazMatClass'
        }
      },
      {
        value: 'CLASS_1_5',
        title: '1.5',
        data: {
          enumValue: 'CLASS_1_5',
          name: '1.5',
          __typename: 'RefHazMatClass'
        }
      }
    ],
    hazMatPackingGroups: [
      {
        value: 'GREAT_DANGER',
        title: 'GreatDanger',
        data: {
          enumValue: 'GREAT_DANGER',
          name: 'GreatDanger',
          __typename: 'RefHazMatPackingGroup'
        }
      },
      {
        value: 'MEDIUM_DANGER',
        title: 'MediumDanger',
        data: {
          enumValue: 'MEDIUM_DANGER',
          name: 'MediumDanger',
          __typename: 'RefHazMatPackingGroup'
        }
      },
      {
        value: 'MINOR_DANGER',
        title: 'MinorDanger',
        data: {
          enumValue: 'MINOR_DANGER',

          name: 'MinorDanger',
          __typename: 'RefHazMatPackingGroup'
        }
      },
      {
        value: 'NONE',
        title: 'None',
        data: {
          enumValue: 'NONE',
          name: 'None',
          __typename: 'RefHazMatPackingGroup'
        }
      }
    ],
    shipmentModes: [
      {
        value: 'LTL',
        title: 'LTL',
        data: { enumValue: 'LTL', name: 'LTL', __typename: 'RefShipmentMode' }
      },
      {
        value: 'PARCEL',
        title: 'Parcel',
        data: {
          enumValue: 'PARCEL',
          name: 'Parcel',
          __typename: 'RefShipmentMode'
        }
      },
      {
        value: 'TRUCK_LOAD',
        title: 'TruckLoad',
        data: {
          enumValue: 'TRUCK_LOAD',
          name: 'TruckLoad',
          __typename: 'RefShipmentMode'
        }
      },
      {
        value: 'VOLUME_LTL',
        title: 'VolumeLTL',
        data: {
          enumValue: 'VOLUME_LTL',
          name: 'VolumeLTL',
          __typename: 'RefShipmentMode'
        }
      }
    ],
    shipmentDirections: [
      {
        value: 'OUTBOUND',
        title: 'Outbound',
        data: {
          enumValue: 'OUTBOUND',
          name: 'Outbound',
          __typename: 'RefShipmentDirection'
        }
      },
      {
        value: 'DROP',
        title: 'Drop',
        data: {
          enumValue: 'DROP',
          name: 'Drop',
          __typename: 'RefShipmentDirection'
        }
      },
      {
        value: 'INBOUND',
        title: 'Inbound',
        data: {
          enumValue: 'INBOUND',
          name: 'Inbound',
          __typename: 'RefShipmentDirection'
        }
      },
      {
        value: 'SHUTTLE',
        title: 'Shuttle',
        data: {
          enumValue: 'SHUTTLE',
          name: 'Shuttle',
          __typename: 'RefShipmentDirection'
        }
      }
    ],
    accessorialServices: [
      {
        value: 'ACCELERATED',
        title: 'Accelerated',
        data: {
          enumValue: 'ACCELERATED',
          name: 'Accelerated',
          description: 'Accelerated',
          __typename: 'RefAccessorialService'
        }
      },
      {
        value: 'AIR_DEL',
        title: 'Airport Delivery',
        data: {
          enumValue: 'AIR_DEL',
          name: 'AirDel',
          description: 'Airport Delivery',
          __typename: 'RefAccessorialService'
        }
      },
      {
        value: 'AIR_PU',
        title: 'Airport Pickup',
        data: {
          enumValue: 'AIR_PU',
          name: 'AirPu',
          description: 'Airport Pickup',
          __typename: 'RefAccessorialService'
        }
      },
      {
        value: 'ARCHR',
        title: 'Arbitrary Charge',
        data: {
          enumValue: 'ARCHR',
          name: 'ArChr',
          description: 'Arbitrary Charge',
          __typename: 'RefAccessorialService'
        }
      },
      {
        value: 'BLIND',
        title: 'Blind Shipment',
        data: {
          enumValue: 'BLIND',
          name: 'Blind',
          description: 'Blind Shipment',
          __typename: 'RefAccessorialService'
        }
      },
      {
        value: 'CAMP_DEL',
        title: 'Camp Delivery',
        data: {
          enumValue: 'CAMP_DEL',
          name: 'CampDel',
          description: 'Camp Delivery',
          __typename: 'RefAccessorialService'
        }
      },
      {
        value: 'CAMP_PU',
        title: 'Camp Pickup',
        data: {
          enumValue: 'CAMP_PU',
          name: 'CampPu',
          description: 'Camp Pickup',
          __typename: 'RefAccessorialService'
        }
      },
      {
        value: 'CAP_LOAD',
        title: 'Capacity Load',
        data: {
          enumValue: 'CAP_LOAD',
          name: 'CapLoad',
          description: 'Capacity Load',
          __typename: 'RefAccessorialService'
        }
      }
    ]
  },
  orgRefs: {
    lcpExceptions: [
      [
        {
          value: '1000',
          title: 'Carrier Already Scheduled to Pickup',
          data: {
            name: 'Carrier Already Scheduled to Pickup',
            description:
              'The Carrier is already scheduled to pickup the shipment.',
            id: '1000',
            __typename: 'LcpExceptionReason'
          }
        },
        {
          value: '1001',
          title: 'LCP + Additional Accessorial',
          data: {
            name: 'LCP + Additional Accessorial',
            description: '',
            id: '1001',
            __typename: 'LcpExceptionReason'
          }
        },
        {
          value: '1002',
          title: "Couldn't Combine Purchase Orders",
          data: {
            name: "Couldn't Combine Purchase Orders",
            description: '',
            id: '1002',
            __typename: 'LcpExceptionReason'
          }
        },
        {
          value: '1003',
          title: 'Customer Request',
          data: {
            name: 'Customer Request',
            description: '',
            id: '1003',
            __typename: 'LcpExceptionReason'
          }
        },
        {
          value: '1004',
          title: 'Local Service Issue',
          data: {
            name: 'Local Service Issue',
            description: '',
            id: '1004',
            __typename: 'LcpExceptionReason'
          }
        },
        {
          value: '1005',
          title: 'Special Equipment Requirement',
          data: {
            name: 'Special Equipment Requirement',
            description: '',
            id: '1005',
            __typename: 'LcpExceptionReason'
          }
        },
        {
          value: '1006',
          title: 'Shipper Request',
          data: {
            name: 'Shipper Request',
            description: '',
            id: '1006',
            __typename: 'LcpExceptionReason'
          }
        },
        {
          value: '1007',
          title: 'Transit Time Requirement',
          data: {
            name: 'Transit Time Requirement',
            description: '',
            id: '1007',
            __typename: 'LcpExceptionReason'
          }
        },
        {
          value: '1008',
          title: 'Vendor Request',
          data: {
            name: 'Vendor Request',
            description: '',
            id: '1008',
            __typename: 'LcpExceptionReason'
          }
        },
        {
          value: '1009',
          title: 'Spot Quote',
          data: {
            name: 'Spot Quote',
            description: '',
            id: '1009',
            __typename: 'LcpExceptionReason'
          }
        },
        {
          value: '1010',
          title: 'Direct vs. Indirect Point',
          data: {
            name: 'Direct vs. Indirect Point',
            description: '',
            id: '1010',
            __typename: 'LcpExceptionReason'
          }
        },
        {
          value: '1011',
          title: 'LCP Capacity Not Available',
          data: {
            name: 'LCP Capacity Not Available',
            description: '',
            id: '1011',
            __typename: 'LcpExceptionReason'
          }
        },
        {
          value: '1012',
          title: 'Other',
          data: {
            name: 'Other',
            description: 'Not captured in other reasons.',
            id: '1012',
            __typename: 'LcpExceptionReason'
          }
        }
      ]
    ],
    glCodes: [
      {
        name: '9282',
        description: 'Cash in Bank',
        id: '1000',
        __typename: 'GlCode'
      },
      {
        name: '5043',
        description: 'Petty Cash',
        id: '1001',
        __typename: 'GlCode'
      },
      {
        name: '0893',
        description: 'Accrued Revenues',
        id: '1002',
        __typename: 'GlCode'
      },
      {
        name: '3785',
        description: 'Cash Revenues',
        id: '1003',
        __typename: 'GlCode'
      },
      {
        name: '0291',
        description: 'Noncash Revenues',
        id: '1004',
        __typename: 'GlCode'
      },
      {
        name: '6789',
        description: 'Other Financing Sources',
        id: '1005',
        __typename: 'GlCode'
      },
      {
        name: '4728',
        description: 'Accounts Payable',
        id: '1006',
        __typename: 'GlCode'
      },
      {
        name: '9483',
        description: 'Interest Payable',
        id: '1007',
        __typename: 'GlCode'
      },
      {
        name: '5244',
        description: 'Claims and Judgments Payable',
        id: '1008',
        __typename: 'GlCode'
      },
      {
        name: '1954',
        description: 'Contracts Payable',
        id: '1009',
        __typename: 'GlCode'
      }
    ]
  },
  orgInfo: {
    orgId: 1000,
    businessId: '1000',
    divisionId: '1000',
    config: {
      defaultCountry: 'US',
      defaultCurrency: 'USD',
      defaultDensityUnit: 'POUNDS_PER_CUBIC_FOOT',
      defaultDimensionUnit: 'INCHES',
      defaultVolumeUnit: 'CUBIC_FEET',
      defaultWeightUnit: 'POUNDS',
      organizationTypeId: 'DEMO',
      p44AccountGroup: null,
      branding: {
        majorLogoUrl: 'majorLogoUrl',
        minorLogoUrl: '',
        navigationColor: '#002940',
        navigationHoverColor: '#14394E',
        navigationActiveColor: '#1F4357',
        frontendPrimaryColor: '#00A1FB',
        frontendPrimaryLightColor: '#F2FAFF',
        frontendPrimaryDarkerColor: '#0053A7',
        frontendSecondaryColor: '#02A1FB',
        frontendSecondaryLightColor: '#E0F4FF',
        frontendSecondaryDarkerColor: '#0068C2',
        productName: 'Propel TMS',
        poweredByUrl: 'propeltms.com',
        supportPhoneNumber: '2158741239',
        supportEmailAddress: 'support@propeltms.com'
      },
      __typename: 'organizationConfig'
    }
  }
};
